import { useState, useRef, useEffect } from "react";

export default function ImageMagnifier({ src, zoom = 2, size = 150 }) {
  const [show, setShow] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0, imgWidth: 0, imgHeight: 0, imgLeft: 0, imgTop: 0 });
  const containerRef = useRef(null);
  const imgRef = useRef(null);

  // Detect mobile device
  useEffect(() => {
    const mobileCheck = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
    setIsMobile(mobileCheck);
  }, []);

  const handleMove = (e) => {
    const containerRect = containerRef.current.getBoundingClientRect();
    const imageRect = imgRef.current.getBoundingClientRect();

    const x = e.clientX - containerRect.left;
    const y = e.clientY - containerRect.top;

    setPos({
      x,
      y,
      imgWidth: imageRect.width,
      imgHeight: imageRect.height,
      imgLeft: imageRect.left - containerRect.left,
      imgTop: imageRect.top - containerRect.top,
    });
  };

  return (
    <div
      ref={containerRef}
      className="magnifier-container"
      onMouseEnter={() => !isMobile && setShow(true)}
      onMouseLeave={() => !isMobile && setShow(false)}
      onMouseMove={(e) => !isMobile && handleMove(e)}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        ref={imgRef}
        src={src}
        alt="magnified"
        className="img-fluid"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          display: "block",
          margin: "auto",
        }}
      />

      {!isMobile && show && (
        <div
          className="magnifier-lens"
          style={{
            position: "absolute",
            pointerEvents: "none",
            width: size,
            height: size,
            borderRadius: "50%",
            border: "2px solid rgba(255, 255, 255, 0.9)",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.45)",
            overflow: "hidden",
            cursor: "none",
            top: pos.y - size / 2,
            left: pos.x - size / 2,
            backgroundImage: `url("${src}")`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${pos.imgWidth * zoom}px ${pos.imgHeight * zoom}px`,
            backgroundPosition: `${-(pos.x - pos.imgLeft) * zoom + size / 2}px ${-(pos.y - pos.imgTop) * zoom + size / 2}px`,
          }}
        />
      )}
    </div>
  );
}
